import { Crest } from "../components/bits";

const PHOTOS = [
  { src: "/brand/hostel-trophies.jpg", cap: "Sports week, the old days", c: "-rotate-6 left-0 top-6 z-10" },
  { src: "/brand/hostel-family.jpg", cap: "One roof. One family.", c: "rotate-3 right-0 top-0 z-20" },
  { src: "/brand/hostel-dining.jpg", cap: "The mess hall", c: "-rotate-1 left-[18%] bottom-0 z-30" },
];

export default function ComingSoon() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="coming-soon-page">
      <main className="flex-1 max-w-6xl w-full mx-auto px-5 py-12 lg:py-20 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <section className="fade-up">
          <div className="flex items-center gap-3">
            <Crest size="h-14 w-14" />
            <span className="leading-none">
              <span className="font-display font-bold text-2xl text-stone-900 block">LVB Hostel</span>
              <span className="font-typewriter text-[11px] uppercase tracking-widest text-amber-800">Andheri, Mumbai • Est. 1904</span>
            </span>
          </div>
          <span className="stamp inline-block text-rose-600 text-sm px-4 py-1.5 -rotate-2 mt-12" data-testid="coming-soon-stamp">Coming soon</span>
          <h1 className="mt-6 text-5xl sm:text-6xl lg:text-7xl font-bold text-stone-900 leading-[1.02]">
            The room changes. The bond doesn't.
          </h1>
          <p className="mt-6 text-base sm:text-lg text-stone-700 max-w-lg leading-relaxed">
            A home for every LVB hostel mate — old batches and new — is being built. Find your batchmates, relive the corridor days and stand by each other, all in one place.
          </p>
          <p className="mt-8 font-typewriter text-sm text-stone-500">Stay tuned, brothers.</p>
        </section>
        <section className="relative h-[340px] sm:h-[440px] fade-up delay-2" aria-hidden>
          {PHOTOS.map((p) => (
            <figure key={p.src} className={`polaroid absolute w-[55%] ${p.c}`}>
              <img src={p.src} alt="" className="vintage-photo w-full aspect-[4/3] object-cover object-top" />
              <figcaption className="caption">{p.cap}</figcaption>
            </figure>
          ))}
        </section>
      </main>
      <footer className="text-center text-xs text-stone-500 font-typewriter py-6">© LVB Hostel family</footer>
    </div>
  );
}
